import { ArrowDownOutlined, ArrowUpOutlined, BorderBottomOutlined, DashboardOutlined, DownOutlined, FileAddOutlined, ImportOutlined, InfoCircleTwoTone, LockOutlined, RightOutlined, SyncOutlined, UploadOutlined } from '@ant-design/icons';
import { Badge, Breadcrumb, Button, Card, Col, Divider, Grid, Input, Modal, notification, Popover, Row, Space, Spin, Statistic, Tabs, Typography } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import "./css/Dashboard.css";
import DateRange from './global/comp/DateRange';
import LincfolioScore from './Usercomp/LincfolioScore';
import AreaGredientChart from './Usercomp/AreaGredientChart';
import BarBothSideChart from './Usercomp/BarBothSideChart';
import Positions from './Usercomp/Positions';
import { setAngelUserId, angelLogout } from '../slices/angelAuthSlice';
import { useDailyJournalMutation, useDashboardCalculationMutation, useSaveNoteMutation } from "../slices/zerodhaApiSlice";
import { setCalculations } from "../slices/dashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useGetCecmasMutation, useGetSubMutation, useGetZerodhaHoldingQuery, useGetShortTermPositionsQuery, useGetOrderHistoryQuery } from '../slices/usersApiSlice';
// import { useUploadCsvMutation } from '../slices/zerodhaApiSlice';
import { useTrackVisitorMutation } from '../slices/visitApiSlice';
import { useGetAngelOrdersQuery } from '../slices/angelOneApiSlice';
import HoldingScreen from './HoldingScreen';
import PositionScreen from './PositionScreen';
// import { useGetAllExecutedTradesQuery } from '../slices/angelOneApiSlice';
import TradeCalendar from './customeCalender';
import moment from 'moment';
import MyEditor from './Usercomp/MyEditor';
import DailyTradeDescription from './Usercomp/DailyTradeDescription';
import AreaGredientChartY from './Usercomp/AreaGredientChartY';
import { setDailyjournal } from '../slices/dailyjournalSlice';
import GrowwPositions from './growwPosition';
import GrowwHoldings from './GrowwHoldings';



const brokerData = [
  { broker: "AngelOne", code: "angelOne" },
  { broker: "Groww", code: "groww" }
];


const DashboardScreen = (props) => {
  
  const [api, contextHolder] = notification.useNotification();
  const { userInfo } = useSelector((state) => state.auth); // Assuming you store logged-in user info here
  const userId = userInfo?._id;
  // const { data: trades, isLoading: tradeLodings } = useGetAllExecutedTradesQuery(userId);
  const [dailyJournal, { isLoading: isJournalLoading }] = useDailyJournalMutation();
  
  // console.log("all trades", trades);
  const { date } = useSelector((state) => state.date);
  const { dashboard } = useSelector((state) => state.dashboard);
  const { darkmode } = useSelector((state) => state.darkmode);
  const { dailyjournal } = useSelector((state) => state.dailyjournal);
  const [modeldata, setModeldata] = useState({});
  const [content, setContent] = useState("");
  const [notetitle, setNotetitle] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [data, setData] = useState([]);
  
  const [getmySub, { isLoading: ismyLoading }] = useGetSubMutation();
  const [currentPlan, setCurrentPlan] = useState(null);
  const [dashboardCalculation, { isLoading: isCalculationLoading }] = useDashboardCalculationMutation();
  const [saveNote, { isLoading: isSaveNoteLoading }] = useSaveNoteMutation();
  
  const [gcemas, { isLoading: isLoading }] = useGetCecmasMutation();
  const [admin, setAdmin] = useState(null);
  // const [uploadCsv] = useUploadCsvMutation();
  const dispatch = useDispatch();
  //   useEffect(() => {
    //     const urlParams = new URLSearchParams(window.location.search);
    //     const angelUserId = urlParams.get("angelUserId");
    // console.log("angeluserid....",angelUserId);
    
    //     if (angelUserId) {
      //       dispatch(setAngelUserId(angelUserId));
      //     }
      //   }, []);
      
      // zerodhaholding shortTermPosition orderHistory
      
      
      // const{data:orders}=useGetAngelOrdersQuery(userId);
      // console.log("angelone fetch orders....",orders);
      
      // const{data}=useGetZerodhaHoldingQuery();
      // console.log(data);
      
      // const response = useGetShortTermPositionsQuery();
      // console.log(response.data);
      
      //  const {data:order} = useGetOrderHistoryQuery();
      //  console.log(order, "order")
      const pageSize = 5; // Cards per page
      
      
      // Fetching journal data with pagination
      const fetchJournal = useCallback(async (page = 1) => {
        try {
          const res = await dailyJournal({
            startDate: date.startDate,
            endDate: date.endDate,
            page,
            pageSize,
          }).unwrap();
          
          if (res && res.data) {
            setData(res.data.results || []); // Update state with the fetched data
            setTotalRecords(res.data.totalCount || 0); // Update total records for pagination
            dispatch(setDailyjournal(res.data)); // If needed for other states
          }
          
          // console.log("daily..journal",res);
          
          
        } catch (err) {
          api.error({ message: err?.data?.message || err.error || err?.data?.error || err?.data?.error });
        }
      }, [dailyJournal, date, dispatch, api]);
      
      useEffect(() => {
        fetchJournal(currentPage);
      }, [currentPage, fetchJournal]); // Depend only on currentPage and fetchJournal
      
      
      const [trackVisitor] = useTrackVisitorMutation();
  useEffect(() => {
    if (!sessionStorage.getItem('siteVisited')) {
      trackVisitor()// Adjust this path to match your backend
      .then(res => res.json())
      .then(data => console.log(data.message))
      .catch(err => console.error('Tracking error:', err));
      
      sessionStorage.setItem('siteVisited', 'true'); // Mark visit tracked
    }
  }, []);
  
  
  // useEffect(() => {
    //         trackVisitor()
    
    //   // const alreadyTracked = localStorage.getItem('visitTracked');
    //   // if (alreadyTracked) {
      //   //   trackVisitor()
      //   //     .unwrap()
      //   //     .then(() => {
        //   //       localStorage.setItem('visitTracked', 'true');
        //   //     })
        //   //     .catch((err) => {
          //   //       console.error('Tracking failed:', err);
          //   //     });
          //   // }
          // }, [trackVisitor]);
          const navigate = useNavigate();
          const getCalculations = async (startDate, endDate) => {
            try {
              const res = await dashboardCalculation({ startDate, endDate }).unwrap();
              console.log(res);
              
              dispatch(setCalculations({ ...res }));
            } catch (err) {
              // console.log(err);
              api.error({
                message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
              });
            }
          }
          
          const getMysub = async () => {
            try {
              const res = await getmySub().unwrap();
              setCurrentPlan(res.subscription);
              console.log(res.subscription);
            } catch (err) {
              console.log(err);
            }
          };
          
          
          const getmas = async () => {
            try {
              const res = await gcemas().unwrap();
              setAdmin(res.user);
            } catch (err) {
              console.log(err);
            }
            
          }
          
          useEffect(() => {
            getMysub();
            getmas();
          }, []);
          
          useEffect(() => {
            // console.log(date.startDate,date.endDate);
            
            getCalculations(date.startDate, date.endDate);
            
            
            try {
              // const res = uploadCsv().unwrap();
              // console.log('Upload Success:', res);
              // alert('Orders uploaded successfully');
            } catch (err) {
              console.error('Upload Failed:', err);
              // alert('Error uploading orders');
            }
          }, [date])
          
          
          
          const [showid, setShowid] = useState(0)
          const show = (show, sid) => [
            showid === sid ? setShowid(0) : setShowid(sid)
          ]
          const { useBreakpoint } = Grid;
          const screens = useBreakpoint();
          const newDate = new Date();
          const { Text, Title } = Typography;
          
          // Sync modal content whenever `modeldata` changes
          useEffect(() => {
            if (modeldata) {
              setNotetitle(modeldata?.note?.title || "");
              setContent(modeldata?.note?.content || "");
            }
          }, [modeldata]);
          
          // Show modal with data
          const showModal = (data) => {
            setModeldata(data || {}); // If `data` is null, reset
            setIsModalOpen(true);
          };
          
          const handleOk = async () => {
            try {
              const _id = modeldata?._id;
              await saveNote({ notetitle, content, _id }).unwrap();
              api.success({ message: "Note Saved!" });
              resetModal();
              // fetchJournal(currentPage);
            } catch (err) {
              api.error({ message: err?.data?.message || err.error || err?.data?.error || err?.data?.error });
            }
          };
          
          const handleCancel = () => {
            resetModal();
          };
          
          // Reset modal states for a clean start
          const resetModal = () => {
            setIsModalOpen(false);
            setModeldata({});
            setNotetitle("");
            setContent(""); // Reset content
          };
          
          const [activeBroker, setActiveBroker] = useState(brokerData[0].code);
          
          return (
            <div>
      {contextHolder}
      <Title level={2} style={{ fontFamily: 'Inter, sans-serif', }}><DashboardOutlined /> Dashboard</Title>
      <Row      gutter={[16, 16]}
  style={{
    backgroundColor: darkmode ? "#141414" : "#FFF",
    borderRadius: "5px"
  }}>

     
        <Col flex={"auto"}>
          <Breadcrumb items={[{ title: 'Dashboard' }, { title: 'Dashboard' }]} style={{ marginBottom: "5px" }} />
          <Space direction="horizontal" style={{ marginBottom: "10px" }}>
            {!screens.lg ? (<DateRange />) : (<></>)}
          </Space>
        </Col>
        {/* <Col flex={"none"}>
          <Space direction={!screens.lg ? "vertical" : "horizontal"} style={{marginBottom: "10px"}}>
            <Text type="secondary"><SyncOutlined/> Last import was: {  newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate()}</Text>
            <Button type='primary' onClick={e => navigate('/ImportTrades')} ghost><ImportOutlined/> Import Trades</Button>
          </Space>
        </Col>         */}
      </Row>
      <Divider />
      <Row gutter={[16, 24]} style={{ marginBottom: "10px" }}>
        <Col md={6} xs={24} style={{ height: "100%" }}>
          <Card bordered={false} className='card_hover' style={{ borderBottom: "2px solid #2980b9", height: "100%" }} >
            <Statistic
              title={"Realised (P&L)"}
              loading={isCalculationLoading}
              value={dashboard != null && dashboard.netrealisedpnl ? Number(dashboard.netrealisedpnl).toFixed(2) : 0}
              precision={2}
              valueStyle={{

                color: dashboard != null && dashboard.netrealisedpnl > 0 ? '#27ae60' : '#2980b9', fontSize: "16px"
              }}
              formatter={(value) => new Intl.NumberFormat('en-IN').format(value)}
              prefix={dashboard != null && dashboard.netrealisedpnl > 0 ? <> <ArrowUpOutlined style={{ color: "#27ae60" }} /> ₹ </> : <><ArrowDownOutlined style={{ color: "#c0392b" }} /> ₹ </>}
            />
          </Card>
        </Col>
        <Col md={6} xs={24} style={{ height: "100%" }}>
          <Card bordered={false} className='card_hover  card_border' style={{ height: "100%" }}>
            <Statistic
              loading={isCalculationLoading}
              title={"Trade Win %"}
              value={dashboard != null && dashboard.winpercent != null ? dashboard.winpercent : 0}
              precision={2}
              valueStyle={{
                color: '#2980b9', fontSize: "16px"
              }}
              prefix={(dashboard != null && dashboard.winpercent != null && dashboard.winpercent >= 50) ? <ArrowUpOutlined style={{ color: "#27ae60" }} /> : <ArrowDownOutlined style={{ color: "#c0392b" }} />}
              suffix="%"
            />
          </Card>
        </Col>
        <Col md={6} xs={24} >
          <Card bordered={false} className='card_hover ' style={{ borderBottom: "2px solid #2980b9", }}>
            {currentPlan != null && admin != null ? (
              currentPlan.plan_id != "68a2df20b2bdf6c04cb5295b" && currentPlan.status == "active" || admin == true ?
                <Statistic
                  loading={isCalculationLoading}
                  title="Profit Factor"
                  value={dashboard != null && dashboard.factor != null ? dashboard.factor : "N/A"}
                  precision={2}
                  valueStyle={{
                    color: '#2980b9', fontSize: "16px"
                  }}
                  prefix={(dashboard != null && (dashboard.factor > 1 || dashboard.factor != null) && dashboard.factor == "Perfect Profit") ? <ArrowUpOutlined style={{ color: "#27ae60" }} /> : <ArrowDownOutlined style={{ color: "#c0392b" }} />}
                  suffix=""
                />
                :
                <Statistic
                  loading={isCalculationLoading}
                  title="Profit Factor"
                  value={"This feature is Premium"}
                  precision={2}
                  valueStyle={{
                    color: '#2980b9', fontSize: "16px"
                  }}
                  prefix={<LockOutlined />}

                />) : (
              <>
                Loadin Please wait... <Spin />
              </>
            )}
          </Card>
        </Col>
        <Col md={6} xs={24}>
          <Card bordered={false} className='card_hover' style={{ borderBottom: "2px solid red  " }}>
            {currentPlan != null && admin != null ? (
              currentPlan.plan_id != "68a2df20b2bdf6c04cb5295b" && currentPlan.status == "active" || admin == true ?
                <Statistic
                  loading={isCalculationLoading}
                  title="Day Win %"
                  value={dashboard != null && dashboard.daywinp != null ? dashboard.daywinp : 0}
                  precision={2}
                  valueStyle={{
                    color: '#2980b9', fontSize: "16px"
                  }}
                  prefix={(dashboard != null && dashboard.daywinp != null && dashboard.daywinp >= 50) ? <ArrowUpOutlined style={{ color: "#27ae60" }} /> : <ArrowDownOutlined style={{ color: "#c0392b" }} />}
                  suffix="%"
                />
                :
                <Statistic
                  loading={isCalculationLoading}
                  title="Day Win %"
                  value={"This feature is Premium"}
                  precision={2}
                  valueStyle={{
                    color: '#2980b9', fontSize: "16px"
                  }}
                  prefix={<LockOutlined />}

                />
            ) : (
              <>
                Loadin Please wait... <Spin />
              </>
            )}
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 24]}>
        <Col md={8} xs={24}>
          <Badge.Ribbon text={"Beta"}>
            <Card title="Lincfolio Score" loading={false} bordered={false} className='card_hover'>
              <Text type='secondary'></Text>
              {currentPlan != null && admin != null ? (
                currentPlan.plan_id != "68a2df20b2bdf6c04cb5295b" && currentPlan.status == "active" || admin == true ?
                  <LincfolioScore date={date} /> : <span>This feature is Premium</span>
              ) : (<>
                Loadin Please wait... <Spin />
              </>)
              }
            </Card>
          </Badge.Ribbon>
        </Col>
        <Col md={8} xs={24}>
          <Badge.Ribbon text={"Beta"} >
            <AreaGredientChart date={date} />
          </Badge.Ribbon>
        </Col>
        <Col md={8} xs={24}>
          <Badge.Ribbon text={"Beta"}>
            <BarBothSideChart date={date} />
          </Badge.Ribbon>
        </Col>
      </Row>
<Row gutter={[16, 24]} style={{ marginTop: 24 }}>

  {/* ANGEL ONE SECTION */}
  <Col span={24}>
    <Card
      title="AngelOne"
      style={{
        borderRadius: 12,
        boxShadow: "0 2px 10px rgba(0,0,0,0.05)"
      }}
    >
      <Row gutter={[16, 24]}>
        <Col md={12} xs={24}>
          <HoldingScreen  />
        </Col>

        <Col md={12} xs={24}>
          <PositionScreen />
        </Col>
      </Row>
    </Card>
  </Col>

  {/* GROWW SECTION */}
  <Col span={24}>
    <Card
      title="Groww"
      style={{
        borderRadius: 12,
        boxShadow: "0 2px 10px rgba(0,0,0,0.05)"
      }}
    >
      <Row gutter={[16, 24]}>
        <Col md={12} xs={24}>
          <GrowwHoldings />
        </Col>

        <Col md={12} xs={24}>

          <GrowwPositions />
        </Col>
      </Row>
    </Card>
  </Col>

</Row>
{/* </Row> */}
      {/* <Row gutter={[16, 24]} >
        <Col md={12} xs={24} >
          <HoldingScreen />
        </Col>
        <Col md={12} xs={24}>
          <PositionScreen />
        </Col>
      </Row> */}
      {/* <Row gutter={[16, 24]} > */}
        <Row gutter={[16, 24]} style={{ marginTop: "10px" }}>
  <Col md={24} xs={24}>
          <Card title="Trade Calendar">
    <TradeCalendar
        journalData={dailyjournal?.results || []}

      onOpenNote={(data) => {
        setModeldata(data);
        setIsModalOpen(true); // opens MyEditor modal 
      }}
    />
    {/* <TradeCalendar /> */}

  </Card>
  </Col>
        
        </Row>

      <Modal
                title={
                    <>
                        <Text>{moment(modeldata?._id).format('ddd, D MMM, YYYY')} <Badge status="default" /></Text>
                     <Text
  type={
    (modeldata?.totalProfit - modeldata?.totalLoss) >= 0
      ? "success"
      : "danger"
  }
>
  Realised P&L ₹{" "}
  {isJournalLoading
    ? 0
    : (modeldata?.totalProfit - modeldata?.totalLoss).toFixed(2)}
</Text>

                    </>
                }
                width={1000}
                open={isModalOpen}
                onOk={handleOk}
                confirmLoading={isSaveNoteLoading}
                onCancel={handleCancel}

            >
                <Row gutter={[16, 24]} style={{ marginBottom: '10px' }}>
                    <Col md={8} xs={24}><AreaGredientChartY datal={isJournalLoading ? [] : modeldata.runningPnlArray} /></Col>
                    <Col md={16} xs={24}><DailyTradeDescription data={modeldata} /></Col>
                </Row>
                <Row>
                    <Input
                        type="text"
                        placeholder="Title"
                        value={notetitle}
                        onChange={(e) => setNotetitle(e.target.value)}
                        style={{ marginBottom: "10px" }}
                    />
                    {isModalOpen && <MyEditor setContent={setContent} initialContent={content} />} {/* Render only when modal is open */}
                </Row>
            </Modal>

                   
    </div>
  )
}

export default DashboardScreen

